module.exports = __webpack_public_path__ + "img/consumo_responsable.8c8ee7fe.png";